'use strict';

/* injects from baggage-loader */

if (window) {
  window._rollbarConfig = require('../../rollbar.config.js');
  require('./rollbar.min.js');
}


//////////////////
// WEBPACK FOOTER
// ./app/entryPoints/rollbar.js
// module id = 622
// module chunks = 1